/**
 * @module 获取当前url的search
 * @author XiaoBin Li(lixiaobin@kuaikeguanjia.com)
 * @see http://gitlab.kuaikeguanjiaop.com/wuyan/common-frontend/blob/master/src/functions/getUrlSearch.js
 */

// let url = require('../utils/url')
import parseQuery from '../utils/url'
/**
 *  获取当前url的search
 */
export default function getUrlSearch() {
	return parseQuery(window.location.search)
}
